export const AssetImages = {
	AUTH_SCREEN : process.env.REACT_APP_WEB_URL + '/malaysia.jpg',
	WEB_APP_LOGO : process.env.REACT_APP_WEB_URL + '/logo-HRX70.png',
	WEB_APP_FAVICON : process.env.REACT_APP_WEB_URL + '/logo-x70.png',
	// USER_DEFAULT_PIC : process.env.REACT_APP_WEB_URL + '/profile-pic.png',
	USER_DEFAULT_PIC : process.env.REACT_APP_WEB_URL + '/user-blank.png',
	UNDER_DEV_IMG : process.env.REACT_APP_WEB_URL + '/under-development.png',
	BUY_LICENSE_IMG: process.env.REACT_APP_WEB_URL + '/ico-license.png',
}